"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageViewEvent = void 0;
const abstract_event_1 = require("../abstract.event");
class PageViewEvent extends abstract_event_1.AbstractEvent {
    constructor(config) {
        super(config);
        this.config = config;
        this.name = 'page_view';
    }
    getData() {
        return this.config;
    }
}
exports.PageViewEvent = PageViewEvent;
//# sourceMappingURL=page-view.event.js.map